import React, {useEffect, useRef, useState} from 'react';
import './scss/style.scss';

import {BrowserRouter, Route, Switch} from 'react-router-dom';
import PwaInstallModal from './components/PwaInstallModal';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// lazy imports mantidos
const Login = React.lazy(() => import('./views/client/login/Login'));
const HomeBroker = React.lazy(() =>
  import('./views/client/home-broker/HomeBroker'),
);
const Bolsa = React.lazy(() =>
  import('./views/client/home-broker/Bolsa/Bolsa'),
);
const ReturnOfCheckout = React.lazy(() =>
  import('./views/client/ReturnOfCheckout'),
);
const ResendUsersEmail = React.lazy(() =>
  import('./views/client/ResendUsersEmail'),
);
const RenewPlan = React.lazy(() => import('./views/client/RenewPlan'));
const AppAdmin = React.lazy(() => import('./AppAdmin'));
const Page404 = React.lazy(() =>
  import('./views/pages/page404/Page404'),
);

const routes = [
  {path: '/', exact: true, component: HomeBroker},
  {path: '/bolsa', exact: true, component: Bolsa},
  {path: '/admin', component: AppAdmin},
  {path: '/login', component: Login},
  {path: '/return-of-checkout', component: ReturnOfCheckout},
  {path: '/resend-email', component: ResendUsersEmail},
  {path: '/renew-plan', component: RenewPlan},
  {path: '*', component: Page404},
];

const App = () => {
  const [showInstall, setShowInstall] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const autoCloseTimer = useRef(null);

  const isIOS = /iphone|ipad|ipod|safari/i.test(navigator.userAgent);
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

  useEffect(() => {
    if (isStandalone) return;
    if (localStorage.getItem('installDismissed')) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);

      // ⏱️ Fecha automaticamente em 10s
      autoCloseTimer.current = setTimeout(() => {
        localStorage.setItem('installDismissed', '1');
        setShowInstall(false);
      }, 6000);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      clearTimeout(autoCloseTimer.current);
    };
  }, [isStandalone]);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    clearTimeout(autoCloseTimer.current);

    deferredPrompt.prompt();
    const {outcome} = await deferredPrompt.userChoice;

    if (outcome === 'dismissed') {
      localStorage.setItem('installDismissed', '1');
    }

    setDeferredPrompt(null);
    setShowInstall(false);
  };

  const handleClose = () => {
    clearTimeout(autoCloseTimer.current);
    localStorage.setItem('installDismissed', '1');
    setShowInstall(false);
  };

  return (
    <>
      <BrowserRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                <route.component/>
              </Route>
            ))}
          </Switch>
        </React.Suspense>
      </BrowserRouter>

      {!isIOS &&
        <PwaInstallModal
          open={showInstall || (isIOS && !isStandalone)}
          onInstall={handleInstall}
          onClose={handleClose}
          isIOS={isIOS}
        />
      }
    </>
  );
};

export default App;
